function validateInput (event) {
  if (event.target.validity.valid) {
    removeInputError(event.target)
  } else {
    addInputError(event.target)
  }
}

function addInputError (element) {
  element.parentNode.classList.add('_state_error')
  element.focus()
}

function removeInputError (element) {
  element.parentNode.classList.remove('_state_error')
}

export default {
  validateInput,
  addInputError,
  removeInputError
}
